<template>
    <!--立即重置-->
    <div class="forgetPwd" :style="{height:height}">
        <div class='content'>
            <div class="main_title">{{ name }}</div>
            <!--<div class="sub_title">找到浩方源，幸福从这里开始</div>-->
            <div class="box" @keyup="keyUp($event)">
                <ul>
                    <li class='phone'>
                        <input type="text" autocomplete="off" v-model.number='resetForm.phone' placeholder="请输入手机号码">
                    </li>
                    <li class='code'>
                        <input type="text" autocomplete="off" v-model='resetForm.forgot_code' placeholder='请输入短信验证码'>
                        <span>{{ mesCode }}</span>
                        <button type='button' @click="getNewCode()">{{ codeMsg }}</button>
                    </li>
                    <li class='pwd'>
                        <input type="text" onFocus="this.type='password'" autocomplete="new-password"
                               v-model='resetForm.password' placeholder="请输入密码">
                        <span>{{ mespass }}</span>
                    </li>
                    <li class='confirmPwd'>
                        <input type="text" onFocus="this.type='password'" autocomplete="new-password"
                               v-model='resetForm.password2' placeholder="请再次输入密码">
                        <span>{{ mespass2 }}</span>
                    </li>
                </ul>
                <button type='button' class="btn" @click="submitForm()">立即重置</button>
            </div>
        </div>

    </div>
</template>

<script type="text/ecmascript-6">
	export default {
		data() {
			return {
				name: '',
				resetForm: {
					phone: "",
					forgot_code: '',
					password: '',
					password2: ''
				},
				msgphone: '',
				mesCode: '',
				mespass: '',
				mespass2: '',
				//倒计时

				codeTime: 60,
				codeTimeout: null,
				height: '',
				codeMsg: '获取验证码',
				ISFS: true, //是否发送  true 默认是可以发送
				YiFa: false,//已发的样式
			}
		},
		created() {
			this.height = window.screen.availHeight - 103 + 'px'
			this.resetForm.phone = JSON.parse(localStorage.getItem('userInfo')).phone
			this.name = localStorage.getItem('meta_title')
		},
		mounted() {
			// console.log(this.$route.query.phone)
			this.init()
		},
		methods: {
			init() {
			},
			keyUp(event) {
				// console.log(event.keyCode)
				if (event.keyCode == 13) {
					// 回车键调用登陆按钮或者登陆方法
					this.submitForm()
				}
			},
			//提交重置密码
			submitForm() {
				if (this.resetForm.forgot_code === '') {
					this.mesCode = '验证码不能为空';
				} else if (this.resetForm.password === '') {
					this.mespass = '密码不能为空';
				} else if (this.resetForm.password2 === '') {
					this.mespass2 = "密码不能为空";
				} else if (this.resetForm.password2 !== this.resetForm.password) {
					this.mespass2 = "密码不一致";
				} else {
					this.mesCode = ''
					this.mespass = ''
					this.mespass2 = ''
					this.$api.Forget(
						this.resetForm,
					).then(res => {
						this.$message({
							message: res.msg, type: 'success'
						})
						this.$addStorageEvent("loginSource", 0);
						this.$router.push({path: '/resetsuccess'})
					}).catch(err => {
						this.$message({
							message: err.msg,
							type: 'warning'
						})
					})
				}
			},
			//获取验证码
			getNewCode() {
				if (this.ISFS === true) {
					this.codeTiming();
				} else {
					this.$message({
						message: '请稍后再试',
					});
				}
			},
			// 获取验证码
			codeTiming() {
				let _this = this;
				this.$api.getForgetCode({
					phone: this.resetForm.phone
				}).then(result => {
					// console.log(result);
					_this.ISFS = false; //更改为不可以发送
					_this.YiFa = true;//更改为不可选的按钮
					if (result.code === 0) {
						let times = 60;
						let dinshiqi = setInterval(function () {
							times--;
							_this.codeMsg = times + "s" + "后重新获取";
							if (times < 1) {
								clearInterval(dinshiqi);
								_this.ISFS = true;
								_this.codeMsg = "获取验证码"
								_this.YiFa = false
							}
						}, 1000);
					}
					else {
						this.mesCode = result.msg
					}
				}).catch(err => {
					this.mesCode = err.msg
				})
			},
		}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .forgetPwd {
        .content {
            .box {
                ul {
                    li {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        border-bottom: 1px solid #D6D6D6;
                        margin-bottom: 30px;
                        input {
                            width: 100%;
                            color: #333333;
                            font-size: 16px;
                            padding: 10px 0;
                            border: none;
                            outline: none;
                        }
                        span {
                            position: absolute;
                            top: 100%;
                            font-size: 14px;
                            color: #ff5e5e;
                        }
                        button {
                            width: 130px;
                            color: #50B3FF;
                            background-color: #ffffff;
                            border: none;
                        }
                    }

                    li:last-child {
                        margin-bottom: 60px;
                    }
                }
            }
        }
    }
</style>